import ToolStylus from './ToolStylus';

class ToolStylusHighlighter extends ToolStylus {
  static toolName = 'Highlighter';

  static action() {
    return true;
  }
}

export default ToolStylusHighlighter;
